import instance from "../../../api";

export const dealsSumAPI = {
  async getStatusDetail(body) {
    return await instance().post('/crm/reports/contract_sum/details/', body).then(res => res?.data)
  }
}
